export const HELP_UTM_CAMPAIGN = {
  RECOMMENDED: 'recommended',
  SEARCH_RESULT: 'search_result',
};
